import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/Reveal";

export const Testimonials = () => {
  const { t } = useLang();
  const { content, L } = useContent();
  const items = content?.testimonials || [];
  if (!items.length) return null;
  return (
    <section className="bg-[#F7F3EC] pt-20 lg:pt-28" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="eyebrow-label mb-6">{t.faqT.testimonialsTitle}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((it) => (
                <blockquote key={it.id} className="bg-white border border-[#191713]/10 p-8" data-testid={`testimonial-${it.id}`}>
                  <p className="font-serif text-lg text-[#191713] italic leading-relaxed">“{L(it.quote)}”</p>
                  <footer className="mt-5 text-sm text-[#191713]/60">{it.name} · {it.business}</footer>
                </blockquote>
              ))}
            </div>
        </Reveal>
      </div>
    </section>
  );
};

export const FaqSection = () => {
  const { t } = useLang();
  const { content, L } = useContent();
  const [open, setOpen] = useState(0);
  const items = content?.faq || [];
  if (!items.length) return null;
  return (
    <section className="bg-[#F7F3EC] py-20 lg:py-28" id="faq" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="eyebrow-label mb-6">{t.faqT.faqTitle}</p>
        </Reveal>
        <div className="mt-4 divide-y divide-[#191713]/10 border-y border-[#191713]/10">
          {items.map((f, i) => (
            <div key={f.id}>
              <button
                data-testid={`faq-toggle-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                aria-expanded={open === i}
                className="w-full flex items-center justify-between gap-6 py-6 text-left"
              >
                <span className="font-serif text-lg sm:text-xl text-[#191713]">{L(f.q)}</span>
                {open === i ? <Minus size={18} className="text-[#A6853B] shrink-0" /> : <Plus size={18} className="text-[#A6853B] shrink-0" />}
              </button>
              {open === i && (
                <p className="pb-6 text-[#191713]/65 leading-relaxed max-w-2xl" data-testid={`faq-answer-${i}`}>{L(f.a)}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
